module.exports = __webpack_public_path__ + "img/brands-pan-logo.png?5e6d81570d585a48f50befd675153ddc";